import styled, { css } from 'styled-components';
import { ifNotProp, switchProp } from 'styled-tools';
import { media } from '@prisjakt/ui-base';
import { colors } from '@prisjakt/ui-base/styles/variables';

// export const VARIANTS = {
//   DEFAULT: 'DEFAULT',
//   CAMPAIGN: 'CAMPAIGN',
//   HEADING: 'HEADING',
//   SOTY: 'SOTY', // (Store of the Year)
//   PRICE_LIST: 'PRICE_LIST',
// };

export enum VARIANTS {
  DEFAULT = 'DEFAULT',
  CAMPAIGN = 'CAMPAIGN',
  HEADING = 'HEADING',
  SOTY = 'SOTY', // (Store of the Year)
  PRICE_LIST = 'PRICE_LIST',
}

export const variantToWidth = {
  [VARIANTS.DEFAULT]: 88,
  [VARIANTS.CAMPAIGN]: 88,
  [VARIANTS.HEADING]: 100,
  [VARIANTS.SOTY]: 176,
  [VARIANTS.PRICE_LIST]: 88,
};

const defaultNoLogoCss = css`
  font-size: 12px;
  line-height: 1.3em;
  word-break: break-word;
  display: flex;
  align-items: center;
`;

const priceListNoLogoCss = css`
  ${defaultNoLogoCss}
  width: 88px;
  text-align: center;
`;

const campaignNoLogoCss = css`
  font-size: 10px;
  color: ${colors.darkBlue2};
  width: 88px;
  max-width: 100%;
  height: 31px;
  line-height: 31px;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border: 1px solid ${colors.lightGray1};
  ${media.mediumUp`
    font-size: 12px;
  `};
`;

const sotyNoLogoCss = css`
  color: ${colors.lightBlue3};
  text-decoration: underline;
`;

type StoreLogoProps = {
  showLogo: boolean;
  variant: 'DEFAULT' | 'CAMPAIGN' | 'HEADING' | 'SOTY' | 'PRICE_LIST';
};

export const StoreLogo = styled.div<StoreLogoProps>`
  height: 31px;

  ${ifNotProp(
    'showLogo',
    switchProp('variant', {
      [VARIANTS.DEFAULT]: defaultNoLogoCss,
      [VARIANTS.HEADING]: defaultNoLogoCss,
      [VARIANTS.PRICE_LIST]: priceListNoLogoCss,
      [VARIANTS.CAMPAIGN]: campaignNoLogoCss,
      [VARIANTS.SOTY]: sotyNoLogoCss,
    })
  )};
`;

export const StoreLogoText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;
